/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-native/no-inline-styles */
import React, {useEffect, useState} from 'react';
import theme from '../../../../../global/styles/theme';
import TextDefault from '../../../../../components/TextDefault';
import {StatusBarContainer} from '../../../../../components/StatusBar';
import * as S from './styles';
import {RootState} from '../../../../../store';
import {useSelector} from 'react-redux';
import {
  ActivityIndicator,
  Dimensions,
  FlatList,
  TouchableOpacity,
  useWindowDimensions,
  View,
} from 'react-native';
import KeyboardScrollView from '../../../../../components/KeyboardScrollView';
import Button from '../../../../../components/Button';
import {useForm} from 'react-hook-form';
import {schemaGavel} from '../../../../../utils/schema';
import {yupResolver} from '@hookform/resolvers/yup';
import DefaultModal from '../../../../../components/DefaultModal';
import Input from '../../../../../components/Input';
import {priceUnmask} from '../../../../../utils/functions';
import {useIsFocused, useNavigation} from '@react-navigation/native';
import {
  bidAuctions,
  createAuctions,
  getAuctions,
} from '../../../../../services/auctions';
import {getTokens} from '../../../../../services/tokens';
import Toast from 'react-native-toast-message';
import {toastConfig} from '../../../../../components/Toast';
import {addHours, lightFormat} from 'date-fns';
import GavelItem from '../../../../../components/GavelItem';
import {SceneMap, TabBar, TabView} from 'react-native-tab-view';
import {getConfigurations} from '../../../../../services/configurations';

const GavelResolver = {
  resolver: yupResolver(schemaGavel),
};

export default function GavelScreen() {
  const listTypeSale = [
    {label: 'Venda direta', value: 'direta'},
    {label: 'Venda oferta', value: 'oferta'},
  ];
  const {
    control,
    handleSubmit,
    reset,
    watch,
    formState: {errors},
  } = useForm(GavelResolver);
  const navigation: any = useNavigation();
  const appTheme = useSelector((state: RootState) => state.config.appTheme);
  const userInfo = useSelector((state: RootState) => state?.user?.user);
  const layout = useWindowDimensions();
  const focusScreen = useIsFocused();

  const initialRoutes = [
    {key: 'ofertas', title: 'Minhas ofertas'},
    {key: 'compras', title: 'Minhas compras'},
  ];

  const [modalGavel, setModalGavel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [qtdPages, setQtdPages] = useState(1);
  const [listGavel, setListGavel] = useState<Array<any>>([]);
  const [listTokens, setListTokens] = useState<Array<any>>([]);
  const [index, setIndex] = useState(0);
  const [routes] = useState(initialRoutes);

  const type = watch('type');

  const handlePress = async (data: any) => {
    if (
      (!data?.valueUnity && data.type === 'direta') ||
      (!data?.minValue && data.type === 'oferta')
    ) {
      Toast.show({
        type: 'error',
        text1: 'O campo de valor é obrigatório.',
      });
      return null;
    }
    const getQtdTokenSelected = listTokens.find(
      e => Number(e.value) === Number(data.idToken),
    );
    if (!getQtdTokenSelected?.qtdExpected) {
      Toast.show({
        type: 'error',
        text1: 'Você não possui mais tokens para negociar.',
      });
      return null;
    }
    if (Number(data.qtd) > getQtdTokenSelected?.qtdExpected) {
      Toast.show({
        type: 'error',
        text1: `Quantidade insuficiente! Selecione uma quantidade igual ou inferior a ${parseFloat(
          getQtdTokenSelected?.qtdExpected,
        )?.toFixed(2)}`,
      });
      return null;
    }
    setIsLoading(true);
    const responseConfig = await getConfigurations(userInfo?.token);
    if (
      !data.offersEndAt ||
      Number(data.offersEndAt) >
        responseConfig?.result?.configuration?.maximum_time_auctions
    ) {
      setIsLoading(false);
      Toast.show({
        type: 'error',
        text1: `Tempo final da oferta precisa ser igual ou inferior a ${responseConfig?.result?.configuration?.maximum_time_auctions}`,
      });
      return null;
    }
    const formatData = {
      ...data,
      idToken: Number(data.idToken),
      offersEndAt: lightFormat(
        addHours(new Date(), Number(data.offersEndAt)),
        'yyyy-MM-dd HH:mm',
      ),
      qtd: Number(data.qtd),
      valueUnity:
        data.type === 'direta' ? priceUnmask(data.valueUnity) : undefined,
      minValue:
        data.type === 'oferta'
          ? priceUnmask(data.minValue || 'R$ 0,00')
          : undefined,
      idUser: userInfo?.user?.id,
    };
    const removeNullValues: any = Object.fromEntries(
      Object.entries(formatData).filter(([_, value]) => value !== undefined),
    );
    await createAuctions(removeNullValues, userInfo?.token)
      .then(async response => {
        setIsLoading(false);
        setModalGavel(false);
        reset();
        getListGavel();
        getListToken();
        Toast.show({
          type: 'success',
          text1: response?.data?.message || 'Dados atualizados!',
        });
      })
      .catch(error => {
        setIsLoading(false);
        Toast.show({
          type: 'error',
          text1:
            error?.response?.data?.message ||
            'Ocorreu um erro, tente novamente mais tarde!',
        });
      });
  };

  const getListGavel = async () => {
    try {
      setIsLoading(true);
      const response = await getAuctions(
        'all',
        undefined,
        !index ? userInfo?.user?.id : undefined,
        index ? userInfo?.user?.id : undefined,
        page,
        userInfo?.token,
      );
      setIsLoading(false);
      setQtdPages(response?.result?.qtdPages || 1);
      setListGavel(response?.result?.list || []);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (focusScreen) {
      const timeoutId = setTimeout(() => {
        getListGavel();
      }, 500);

      return () => clearTimeout(timeoutId);
    }
  }, [page, index, focusScreen]);

  function onEndReached() {
    if (page < qtdPages) {
      setPage(page + 1);
    }
  }

  const getListToken = async () => {
    try {
      const response = await getTokens(
        userInfo?.user?.id,
        1,
        1000,
        userInfo?.token,
      );
      const formatListTokens = (response?.result?.list || []).map((v: any) => ({
        value: v.token.id,
        label: v.token.name,
        qtdExpected:
          parseFloat(v.total_qtd || 0) - parseFloat(v.total_qtd_auctions || 0),
      }));
      setListTokens(formatListTokens);
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    getListToken();
  }, []);

  const acceptTrade = async (item: any) => {
    setIsLoading(true);
    const formatData = {
      value: item.bid.value,
      idUserBid: item.bid.user_id,
      idAuction: item?.id,
      execute: true,
    };
    await bidAuctions(formatData, userInfo?.token)
      .then(async response => {
        setIsLoading(false);
        getListGavel();
        getListToken();
        Toast.show({
          type: 'success',
          text1: response?.data?.message || 'Dados atualizados!',
        });
      })
      .catch(error => {
        setIsLoading(false);
        Toast.show({
          type: 'error',
          text1:
            error?.response?.data?.message ||
            'Ocorreu um erro, tente novamente mais tarde!',
        });
      });
  };

  const ofertas = () => {
    if (isLoading) {
      return (
        <ActivityIndicator
          size="large"
          color={theme.colors(appTheme).white}
          style={{marginTop: 40}}
        />
      );
    }
    return (
      <FlatList
        data={listGavel}
        renderItem={({item}) => {
          return (
            <GavelItem
              item={item}
              acceptTrade={acceptTrade}
              isLoading={isLoading}
            />
          );
        }}
        keyExtractor={item => String(item.id)}
        style={{width: '100%'}}
        contentContainerStyle={{
          paddingBottom: 60,
          paddingTop: 20,
          alignItems: 'center',
        }}
        indicatorStyle={appTheme === 'dark' ? 'white' : 'black'}
        onEndReached={onEndReached}
        onEndReachedThreshold={0.3}
      />
    );
  };

  const compras = () => {
    if (isLoading) {
      return (
        <ActivityIndicator
          size="large"
          color={theme.colors(appTheme).white}
          style={{marginTop: 40}}
        />
      );
    }
    return (
      <FlatList
        data={listGavel}
        renderItem={({item}) => {
          return (
            <GavelItem
              item={item}
              acceptTrade={acceptTrade}
              isLoading={isLoading}
            />
          );
        }}
        keyExtractor={item => String(item.id)}
        style={{width: '100%'}}
        contentContainerStyle={{
          paddingBottom: 60,
          paddingTop: 20,
          alignItems: 'center',
        }}
        indicatorStyle={appTheme === 'dark' ? 'white' : 'black'}
        onEndReached={onEndReached}
        onEndReachedThreshold={0.3}
      />
    );
  };

  const renderScene = SceneMap({
    ofertas,
    compras,
  });

  const renderTabBar = (propsTabView: any) => {
    return (
      <TabBar
        {...propsTabView}
        renderTabBarItem={renderTabBarItem}
        indicatorStyle={{
          backgroundColor: 'white',
          elevation: 0,
          height: 3,
        }}
        style={{
          alignSelf: 'center',
          backgroundColor: theme.colors(appTheme).black[500],
          elevation: 0,
          shadowOffset: {
            height: 0,
            width: 0,
          },
          shadowColor: 'transparent',
          shadowRadius: 0,
          shadowOpacity: 1,
          width: '100%',
        }}
        contentContainerStyle={{
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        }}
        renderIndicator={() => null}
      />
    );
  };

  const renderTabBarItem = (propsTabBar: any) => {
    const {title} = propsTabBar.route;
    const focus = title === initialRoutes[index].title;

    return (
      // @ts-ignore
      <TouchableOpacity
        {...propsTabBar}
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          paddingTop: 10,
          width: layout.width / 2,
        }}>
        <TextDefault
          text={title}
          color={
            focus
              ? theme.colors(appTheme).main[700]
              : theme.colors(appTheme).white
          }
          fontSize={14}
        />
        <S.BottomMarked
          style={{
            backgroundColor: focus
              ? theme.colors(appTheme).main[700]
              : 'transparent',
          }}
        />
      </TouchableOpacity>
    );
  };

  const onChangeIndex = (indexActual: number) => {
    setIndex(indexActual);
  };

  return (
    <>
      <StatusBarContainer />
      <S.Container appTheme={appTheme}>
        <S.ContainerArea appTheme={appTheme}>
          <S.HeaderList>
            <S.ButtonGoBack onPress={() => navigation.goBack()}>
              <S.IconImage
                color={theme.colors(appTheme).white}
                size={26}
                name="arrow-left"
              />
            </S.ButtonGoBack>
            <TextDefault
              fontSize={18}
              color={theme.colors(appTheme).white}
              text="Meus leilões"
              fontFamily={theme.fonts.family.opensans.semi_bold}
              textAlign="center"
            />
            <Button
              title="NOVO LEILÃO"
              onPress={() => setModalGavel(true)}
              fontFamily={theme.fonts.family.opensans.bold}
              width={120}
            />
          </S.HeaderList>
          <TabView
            navigationState={{index, routes}}
            renderScene={renderScene}
            renderTabBar={renderTabBar}
            onIndexChange={onChangeIndex}
            initialLayout={{width: layout.width}}
            style={{
              // height: 50,
              width: '100%',
            }}
          />
        </S.ContainerArea>
        <DefaultModal
          modalVisible={modalGavel}
          setModalVisible={setModalGavel}
          onClose={() => {
            reset();
          }}>
          <S.ContainerModal appTheme={appTheme}>
            <View
              style={{
                position: 'absolute',
                left: 0,
                top: -120,
                width: Dimensions.get('window').width / 1.1,
                zIndex: 1,
              }}>
              <Toast config={toastConfig} />
            </View>
            <KeyboardScrollView>
              <S.Body>
                <TextDefault
                  fontSize={20}
                  color={theme.colors(appTheme).white}
                  marginBottom={20}
                  text="Criar leilão"
                  fontFamily={theme.fonts.family.opensans.semi_bold}
                />
                <Input
                  title="Qual token deseja ofertar?"
                  errors={errors}
                  placeholder="Nenhum token selecionado"
                  control={control}
                  name="idToken"
                  marginTop={10}
                  width="100%"
                  hideBorder
                  isDropdown
                  options={listTokens}
                />
                <Input
                  title="Quantidade de tokens"
                  errors={errors}
                  placeholder="Ex.: 100"
                  control={control}
                  name="qtd"
                  marginTop={10}
                  width="100%"
                  hideBorder
                  keyboardType="phone-pad"
                />
                <Input
                  title="Qual tipo da venda?"
                  errors={errors}
                  placeholder="Nenhum tipo selecionado"
                  control={control}
                  name="type"
                  marginTop={10}
                  width="100%"
                  hideBorder
                  isDropdown
                  options={listTypeSale}
                />
                {!type ? null : type === 'direta' ? (
                  <Input
                    title="Valor unitário do token"
                    errors={errors}
                    placeholder="Ex.: R$ 100,00"
                    control={control}
                    name="valueUnity"
                    marginTop={10}
                    width="100%"
                    mask="money"
                    hideBorder
                    keyboardType="phone-pad"
                  />
                ) : (
                  <>
                    <Input
                      title="Lance mínimo"
                      errors={errors}
                      placeholder="Ex.: R$ 100,00"
                      control={control}
                      name="minValue"
                      marginTop={10}
                      width="100%"
                      mask="money"
                      hideBorder
                      keyboardType="phone-pad"
                    />
                  </>
                )}
                <Input
                  title="Tempo final da oferta (horas)"
                  errors={errors}
                  control={control}
                  name="offersEndAt"
                  marginTop={10}
                  width="100%"
                  placeholder="Ex.: 24"
                  mask="number"
                  keyboardType="numeric"
                  hideBorder
                />
                <Button
                  title="SALVAR DADOS"
                  onPress={handleSubmit(handlePress)}
                  fontFamily={theme.fonts.family.opensans.bold}
                  marginTop={20}
                  isLoading={isLoading}
                />
              </S.Body>
            </KeyboardScrollView>
          </S.ContainerModal>
        </DefaultModal>
        {modalGavel ? null : <Toast config={toastConfig} />}
      </S.Container>
    </>
  );
}
